export default __webpack_public_path__ + "assets/pdf/RexelEnergyCreditApplication.cf6b6b10.pdf";